import { P00039DataRxTxIndex } from '../../P00039Sync';
import { IProduct } from '../../../IProduct';
import { getPoolMasterClass } from '../../../../ECoSystemsHelper';
import { Pool } from '../../../../../../apis/pool.api';

export function P00039InstallationFinish(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
): boolean {
  const master = getPoolMasterClass(pool);
  const presence = master?.hasProduct(pool, productClass) ?? 0;

  editValue(
    P00039DataRxTxIndex.Maitre_Installation,
    'maitreIInstallationOk',
    presence != 0,
    null,
    productClass,
  );

  return false;
}
